import { useEffect } from "react";
import { toDisplayString } from "../../utils/normalizeApiError";
import { showSuccessScreen } from "../common/successScreenBus";

/**
 * Success notice for admin save/update flows. Shows the shared success screen
 * (same design as Mark Attendance) instead of an inline card; ``onDismiss`` /
 * ``autoDismissMs`` still clear the caller's state as before.
 */
export default function SuccessCelebration({
  open = true,
  title = "Updated successfully",
  message,
  onDismiss,
  autoDismissMs = 0,
}) {
  const displayTitle = toDisplayString(title, "Updated successfully");
  const displayMessage = toDisplayString(message);
  const active = open && Boolean(displayTitle || displayMessage);

  useEffect(() => {
    // The specific message (e.g. "PF settings saved.") reads better than the generic title.
    if (active) showSuccessScreen(displayMessage || displayTitle);
  }, [active, displayTitle, displayMessage]);

  useEffect(() => {
    if (!active || !autoDismissMs || !onDismiss) return undefined;
    const t = setTimeout(onDismiss, autoDismissMs);
    return () => clearTimeout(t);
  }, [active, autoDismissMs, onDismiss]);

  return null;
}
